import { createAction, props } from '@ngrx/store';
import { LoadingInfo } from '../../../api';
export enum SubmissionPageActionTypes {
  Clear = '[SubmissionPage] Clear',

  GetUserSettings = '[Submissions Page] Get User Settings',
  GetUserSettingsSuccess = '[Submissions Page] Get User Settings Success',
  GetUserSettingsFail = '[Submissions Page] Get User Settings Fail',

  SetFiltersPreferences = '[Dashboard Page] Set Filters Preferences',

  SetTableState = '[Submissions Page] Set Table State',

  SetUserSettings = '[Submissions Page] Set User Settings',
  SetUserSettingsSuccess = '[Submissions Page] Set User Settings Success',
  SetUserSettingsFail = '[Submissions Page] Set User Settings Fail',

  SetLatestSearchId = '[Submissions Page] Set Latest Search Id',

  ResetFilters = '[Submissions Page] Reset Filters'
}

export const clear = createAction(SubmissionPageActionTypes.Clear);

export const setTableState = createAction(SubmissionPageActionTypes.SetTableState, props<{ tableState: LoadingInfo }>());

export const getUserSettings = createAction(SubmissionPageActionTypes.GetUserSettings, props<{ versionFlag: string }>());
export const getUserSettingsSuccess = createAction(SubmissionPageActionTypes.GetUserSettingsSuccess, props<{ settings: Record<string, any> }>());
export const getUserSettingsFail = createAction(SubmissionPageActionTypes.GetUserSettingsFail, props<{ error: Error }>());

export const setUserSettings = createAction(SubmissionPageActionTypes.SetUserSettings, props<{ settings: Record<string, any>; versionFlag: string }>());
export const setUserSettingsSuccess = createAction(
  SubmissionPageActionTypes.SetUserSettingsSuccess,
  props<{ settings: Record<string, any>; shouldNavigate?: boolean }>()
);
export const setUserSettingsFail = createAction(SubmissionPageActionTypes.SetUserSettingsFail, props<{ error: Error }>());

export const setFiltersPreferences = createAction(
  SubmissionPageActionTypes.SetFiltersPreferences,
  props<{ filtersPreferences: Pick<LoadingInfo, 'filters'> }>()
);

export const setLatestSearchId = createAction(SubmissionPageActionTypes.SetLatestSearchId, props<{ searchId: number }>());

export const resetFilters = createAction(SubmissionPageActionTypes.ResetFilters);
